import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Button, tokens } from '@fhs/ui';

export const ItemDetailsFooter = ({
  onSaveItem,
  isLoading,
}: {
  onSaveItem: () => void;
  isLoading?: boolean;
}) => {
  return (
    <View style={styles.footer}>
      <Button
        onPress={onSaveItem}
        style={styles.addItemCTAButton}
        disabled={isLoading}
        loading={isLoading}
      >
        <Button.Text>Add Item</Button.Text>
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    backgroundColor: tokens.colors.$white,
    padding: 16,
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 52,
    borderTopWidth: 1,
    borderColor: tokens.colors.$black10,
  },
  addItemCTAButton: {
    flex: 1,
    fontSize: 18,
    height: 48,
  },
});
